import type { Profile } from '@here/api'
import BlockEmbed from 'quill/blots/embed'
import Inline from 'quill/blots/inline'

export class AudioBlot extends BlockEmbed {
	static blotName = 'audio'
	static tagName = 'audio'
	static className = 'ql-audio'

	static create(value: string) {
		const node = super.create() as HTMLAudioElement
		node.setAttribute('controls', '')
		node.setAttribute('src', value)
		return node
	}

	static value(node: HTMLAudioElement) {
		return node.getAttribute('src')
	}
}

export const formats = [
	'bold',
	'italic',
	'underline',
	'strike',
	'align',
	'list',
	'indent',
	'size',
	'header',
	'link',
	'image',
	'audio',
	'video',
]

export class MentionBlot extends Inline {
	static blotName = 'mention'
	static tagName = 'span'
	static className = 'mention-blot'

	static create(value: Profile) {
		const node = super.create()
		node.setAttribute('data-mention-username', value.username ?? '')
		node.setAttribute('data-mention-id', value.id)
		node.textContent = `@${value.username}`
		return node
	}

	static formats(node: HTMLElement) {
		return {
			username: node.getAttribute('data-mention-username') ?? '',
			id: node.getAttribute('data-mention-id') ?? '',
		}
	}
}
